import Hero from './components/parts/hero';

// Component instances storage
const componentInstances = new Map<HTMLElement, any>();

// Initialize home-specific components
function initializeHomeComponents(): void {
  console.log('[Home] Initializing home components...');

  // Initialize Hero (should be only one)
  const hero = document.querySelector<HTMLElement>('.js-hero');
  console.log('[Home] Hero:', hero);
  if (hero && !componentInstances.has(hero)) {
    const instance = new Hero(hero);
    componentInstances.set(hero, instance);
  }

  console.log('[Home] Components initialized. Total instances:', componentInstances.size);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHomeComponents);
} else {
  initializeHomeComponents();
}
